import { render, staticRenderFns } from "./SpotlightCallout.vue?vue&type=template&id=1cde900a&scoped=true&"
import script from "./SpotlightCallout.vue?vue&type=script&lang=js&"
export * from "./SpotlightCallout.vue?vue&type=script&lang=js&"
import style0 from "./SpotlightCallout.vue?vue&type=style&index=0&id=1cde900a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cde900a",
  null
  
)

export default component.exports